import React, { useState } from "react";

function Feedback({ sessionId, setMessages, setShowFeedbackModal, setFeedbackAvailable }) {

  const [isSlidingDownFeedback, setIsSlidingDownFeedback] = useState(false);

  const [feedbackSlide, setFeedbackSlide] = useState(1);  // 1 for rating, 2 for comments
  const [rating, setRating] = useState(null);
  const [comment, setComment] = useState("");


  const cancelFeedback = () => {
    setIsSlidingDownFeedback(true);
    setTimeout(() => {
      setShowFeedbackModal(false);
      setIsSlidingDownFeedback(false);
    }, 300);
  };

  const submitFeedback = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/submit_feedback`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ session_id: sessionId, rating, comment }),
      });

      let newMessage;
      if (response.ok) {
        newMessage = {
          sender: "Rival AI",
          text: '<span class="tw-italic">Thank you for your feedback.</span>',
        };
        resetFeedbackStates(true);
      } else {
        newMessage = {
          sender: "Rival AI",
          text: '<span class="tw-italic chatbot-error-msg">Oops! Something went wrong. Please try again later.</span>',
        };
        resetFeedbackStates(false);
      }

      setMessages(prevMessages => [...prevMessages, newMessage]);
    } catch (error) {
      setMessages(prevMessages => [
        ...prevMessages,
        {
          sender: "Rival AI",
          text: `<span class="chatbot-error-msg tw-italic">We're experiencing some issues sending this feedback.<br/><span class="tw-text-xs">(Error Message: ${error.message})</span></span>`,
        },
      ]);
      resetFeedbackStates(false);
    }
  };

  const resetFeedbackStates = (isSuccess) => {
    setShowFeedbackModal(false);
    setFeedbackSlide(1);
    if (isSuccess) {
      setRating(null);
      setComment("");
      setFeedbackAvailable(false);
    }
  };

  return (
    <div className={`feedback-modal tw-fixed tw-bottom-6 tw-bg-white tw-p-4 tw-rounded tw-shadow-lg tw-backdrop-blur-sm ${isSlidingDownFeedback ? "slide-down" : ""}`} style={{ zIndex: 10001 }}>
      <div className="tw-relative">
        {feedbackSlide === 1 ? (
          // Slide 1 - Rating
          <>
            <h1 className="tw-grow tw-text-lg tw-font-semibold tw-tracking-tight tw-leading-tight tw-text-center tw-m-0 tw-p-0 tw-m-0">
              Overall, how would you rate your ROSI experience?
            </h1>
            <div className="tw-flex tw-justify-center tw-my-8">
              {[1, 2, 3, 4, 5].map((rate) => (
                <button
                  key={rate}
                  className={`tw-w-10 tw-h-10 tw-rounded-full tw-border-0 tw-mx-1 tw-text-lg ${rating === rate ? 'tw-bg-notblurple tw-text-white' : 'tw-bg-notblurple-10 tw-text-rivalcharcoal'}`}
                  onClick={() => setRating(rate)}
                >
                  {rate}
                </button>
              ))}
            </div>
            <div className="tw-flex tw-justify-between">
              <button
                onClick={cancelFeedback}
                className="tw-bg-rivalcharcoal tw-border-0 tw-text-sm tw-text-white tw-px-3 tw-py-2 tw-rounded hover:tw-opacity-90"
              >
                Cancel
              </button>
              <button
                onClick={() => setFeedbackSlide(2)}
                className="tw-bg-notblurple tw-border-0 tw-text-sm tw-text-white tw-px-3 tw-py-2 tw-rounded hover:tw-opacity-90"
                disabled={rating === null}
              >
                Next
              </button>
            </div>
          </>
        ) : (
          // Slide 2 - Comments
          <>
            <h1 className="tw-grow tw-text-lg tw-font-semibold tw-tracking-tight tw-leading-tight tw-text-center tw-m-0 tw-p-0 tw-mb-2">
              Comments (Optional)
            </h1>
            <textarea
              className="tw-w-full tw-max-h-24 tw-h-svh tw-rounded-md tw-border tw-border-rivalgrey tw-p-2 tw-my-6 tw-text-sm"
              placeholder="Tell us about your experience.."
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />
            <div className="tw-flex tw-justify-between">
              <button
                onClick={cancelFeedback}
                className="tw-bg-rivalcharcoal tw-border-0 tw-text-sm tw-text-white tw-px-3 tw-py-2 tw-rounded hover:tw-opacity-90"
              >
                Cancel
              </button>
              <button
                onClick={submitFeedback}
                className="tw-bg-notblurple tw-border-0 tw-text-sm tw-text-white tw-px-3 tw-py-2 tw-rounded hover:tw-opacity-90"
              >
                Submit
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default Feedback;
